// Общая подготовка истории статусов: новые события сверху, подписи из конфигурации сущности.
export function buildStatusHistory(transitions = [], options = []) {
  const status = (value) => options.find((option) => option.value === value)
    || { value, label: value || "Не указан", color: "#64748b" };
  return transitions.map((transition) => ({
    ...transition,
    time: transition.occurred_at || transition.created_at,
    from: status(transition.from_status),
    to: status(transition.to_status),
  })).sort((a, b) => (Date.parse(b.time) || 0) - (Date.parse(a.time) || 0) || Number(b.id) - Number(a.id));
}
